import { useContext, useEffect, useState } from "react";
import MainLayout from "../Container/Layout/MainLayout";
// context
import { Context } from "../Context/Context";
// style
import styles from "../Styles/UploadFile/UploadFileLoading.module.css"
import { useLocation, useNavigate } from "react-router-dom";
import { getEditOrder } from "../Services/ContectService";
import { toast } from "react-toastify";

const UploadFileLoading = () => {
    const { json, user } = useContext(Context);
    let navigate = useNavigate();
    const location = useLocation();

    let timeout;
    let interval;

    const content = json?.UploadFileLoading;
    const toastContect = json?.toast;

    const handleGetServiceDetails = async (code) => {
        try {
            const response = await getEditOrder(user, code);
            if (response.status === 200) {
                clearInterval(interval);
                return navigate(`/editOrder/${code}`, {
                    state: response.data
                });
            }
            else if (response.status === 204) {
                callHandleGetServiceDetails();
            }
        } catch (error) {
            toast.error(toastContect.err_1);
            return navigate(-1);
        }
    };

    const callHandleGetServiceDetails = () => {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
            handleGetServiceDetails(location.state.code);
        }, 10000);
    }

    const timer = () => {
        if (!interval) {
            var elem = document.getElementById("myBar");
            var width = 0;
            interval = setInterval(() => {
                if (width >= 100) {
                    width = 0;
                } else {
                    width += 0.5;
                    elem.style.width = width + "%";
                }
            }, 50);
        }
    }

    useEffect(() => {
        if (!location.state) {
            toast.error(toastContect.err_1);
            return navigate(-1);
        }
        timer();
        handleGetServiceDetails(location.state.code);

        return () => {
            clearTimeout(timeout);
            clearInterval(interval);
        };
    }, []);

    return (
        <MainLayout>
            <div className="d-flex flex-wrap gap-3">
                <div className={styles.uploadStatus}>
                    <img src="/imgs/upload/uploadLoading.png" alt="" />
                    <div className={styles.uploadStatusContent}>
                        {/* <p id="numberBar"></p> */}
                        <div className={styles.timerFarme}>
                            <div className={styles.timer} id="myBar"></div>
                        </div>
                        <p>{content.condition}</p>
                    </div>

                </div>
                <div className={styles.uploadInformation}>
                    <div
                        className={styles.uploadPreview}
                        style={{
                            backgroundColor: "white",
                            maxHeight: "320px"
                        }}
                    >
                        <img src="/imgs/upload/wisercam image.png" alt="Wisercam" />
                    </div>
                    <div className={styles.uploadMessage}>
                        <h3 className={styles.uploadMessageTitle}>{content.analysisTitle}</h3>
                        <p className={styles.uploadMessageDescription}>{content.analysisInfo}</p>
                        <button
                            onClick={() => {
                                clearTimeout(timeout);
                                clearInterval(interval);
                                navigate("/")
                            }}
                            className={styles.uploadMessageBtn}
                        >
                            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M28.5002 15.9999C28.5002 16.3977 28.3422 16.7792 28.0609 17.0605C27.7796 17.3419 27.398 17.4999 27.0002 17.4999H8.62521L15.0652 23.9386C15.347 24.2204 15.5053 24.6026 15.5053 25.0011C15.5053 25.3997 15.347 25.7818 15.0652 26.0636C14.7834 26.3454 14.4012 26.5037 14.0027 26.5037C13.6042 26.5037 13.222 26.3454 12.9402 26.0636L3.94021 17.0636C3.80037 16.9243 3.68941 16.7587 3.6137 16.5764C3.53799 16.394 3.49902 16.1986 3.49902 16.0011C3.49902 15.8037 3.53799 15.6082 3.6137 15.4259C3.68941 15.2436 3.80037 15.078 3.94021 14.9386L12.9402 5.93864C13.0797 5.79911 13.2454 5.68843 13.4277 5.61291C13.61 5.5374 13.8054 5.49854 14.0027 5.49854C14.2 5.49854 14.3954 5.5374 14.5777 5.61291C14.76 5.68843 14.9257 5.79911 15.0652 5.93864C15.2047 6.07817 15.3154 6.24381 15.3909 6.42612C15.4664 6.60842 15.5053 6.80381 15.5053 7.00114C15.5053 7.19846 15.4664 7.39385 15.3909 7.57616C15.3154 7.75846 15.2047 7.92411 15.0652 8.06364L8.62521 14.4999H27.0002C27.398 14.4999 27.7796 14.6579 28.0609 14.9392C28.3422 15.2205 28.5002 15.6021 28.5002 15.9999Z" fill="white" />
                            </svg>
                            {content.analysisBtn}
                        </button>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
}

export default UploadFileLoading;
